/* eslint-disable no-unused-vars */
import { Grid, Typography } from "@mui/material";
import PDialog from "../../components/pos/PDialog";
import PText from "../../components/pos/PText";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PricingUtils } from "../../utils/PricingUtils";
export const OpenQtyDialog = (props) => {
  const { t } = useTranslation();
  const translate = t;
  props.biRef.OpenQtyDialog = {
    parentEvent: parentEvent,
  };

  const [openWindow, setOpenWindow] = useState(true);

  const [price, setPrice] = useState("");
  const [priceError, setPriceError] = useState("");

  const [qty, setQty] = useState("");
  const [qtyError, setQtyError] = useState("");

  const [amount, setAmount] = useState("");
  const [amountError, setAmountError] = useState("");

  function onCloseWindow() {
    props.setOpenWindow(false);
  }

  useEffect(() => {
    let result = PricingUtils.derivePrice(
      props.context.store.currencyDecimal,
      props.pricingBean.cost,
      props.pricingBean.price,
      props.productBean.includeTaxInPrice,
      props.productBean.taxBean.rate,
      props.productBean.includeDiscountInPrice,
      0,
      null,
      props.productBean.isDiscounted,
      1,
      false
    );
    setPrice(result.netAmount);
  }, [props.pricingBean]);

  function parentEvent(event, value) {
    if ("openWindow" === event) {
      setOpenWindow(value);
      setAmount("");
      setQty("");
    }
  }

  function onSave() {
    // if (validate()) {
    if (price === "" || parseFloat(price) <= 0) {
      setPriceError(translate("Please Enter Price"));
      return false;
    } else if (qty === "" || parseFloat(qty) <= 0) {
      setQtyError(translate("Please Enter Quantity"));
      return false;
    } else if (amount === "" || parseFloat(amount) <= 0) {
      setAmountError(translate("Please Enter Amount"));
      return false;
    } else {
      props.updateQty(qty, price);
      setOpenWindow(false);
    }
    //}
  }

  function valdate() {
    /*if (qty === "" || parseFloat(qty) < 0) {
      
    }*/
    return true;
  }

  function onChangeQty(newQty) {
    setQty(newQty);
    if (price === "" || parseFloat(price) <= 0) {
      return false;
    }
    let result = PricingUtils.derivePrice(
      props.context.store.currencyDecimal,
      props.pricingBean.cost,
      price,
      true,
      props.productBean.taxBean.rate,
      true,
      0,
      null,
      false,
      parseFloat(newQty),
      false
    );
    setAmount(result.netAmount);
  }

  function onChangeAmount(newAmount) {
    setAmount(newAmount);

    let result = PricingUtils.derivePrice(
      props.context.store.currencyDecimal,
      props.pricingBean.cost,
      price,
      true,
      props.productBean.taxBean.rate,
      true,
      0,
      null,
      false,
      1,
      false
    );

    console.log(JSON.stringify(result));

    let newQty = parseFloat(newAmount) / result.netAmount;

    setQty(PricingUtils.formattedNumber(newQty, 4));
  }

  function onChangePrice(newPrice) {
    setPrice(newPrice);
    if (qty === "" || parseFloat(qty) <= 0) {
      return false;
    }
    setAmount(
      PricingUtils.formattedNumber(parseFloat(qty) * parseFloat(newPrice))
    );
  }

  function onDelete() {}
  const content = (
    <Grid container>
      {props.productBean.isOpenPrice && (
        <Grid item xs={12}>
          <Typography variant="body1" style={{ marginLeft: 5 }}>
            {translate("Price")}
          </Typography>
        </Grid>
      )}
      {props.productBean.isOpenPrice && (
        <Grid item xs={12}>
          <PText
            value={price}
            autoFocus={true}
            type="number"
            error={priceError}
            onChange={(e) => {
              onChangePrice(e.target.value);
              setQtyError("");
            }}
          ></PText>
        </Grid>
      )}

      <Grid item xs={12}>
        <Typography variant="body1" style={{ marginLeft: 5 }}>
          {translate("Quantity")}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <PText
          value={qty}
          autoFocus={true}
          type="number"
          error={qtyError}
          onChange={(e) => {
            onChangeQty(e.target.value);
            setQty(e.target.value);
            setQtyError("");
          }}
        ></PText>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" style={{ marginLeft: 5 }}>
          {translate("Amount")}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <PText
          value={amount}
          autoFocus={false}
          type="number"
          error={amountError}
          onChange={(e) => {
            onChangeAmount(e.target.value);
            setAmountError("");
          }}
        ></PText>
      </Grid>
    </Grid>
  );
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={translate("Enter Quantity")}
          maxWidth={"md"}
          fullWidth={false}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          saveLabel={translate("Proceed")}
          mode={"create"}
        ></PDialog>
      )}
    </div>
  );
};
export default OpenQtyDialog;
